import { render, staticRenderFns } from "./WalletCategoriesManager.vue?vue&type=template&id=37f43ce6&scoped=true&"
import script from "./WalletCategoriesManager.vue?vue&type=script&lang=js&"
export * from "./WalletCategoriesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f43ce6",
  null
  
)

export default component.exports